var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"flat":""}},[_c('mw-edit',{attrs:{"id":_vm.id,"storeModule":"organisations","model":_vm.model,"title-key":"name","path":"organisations"},on:{"saved":function($event){return _vm.$emit('saved')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }